<template>
  <div class="history-applicant">
    <div class="page-header">
      <div class="search-box">
        <el-input
          class="search-input"
          placeholder="请输入申请人姓名或护照号"
          v-model="condition"
          @input="onChangeCondition"
        />
      </div>
    </div>
    <div class="applicant-box">
      <div v-if="!isNodata && !layout.searchedCondition && activeLetter" class="fixed-nav">{{ activeLetter }}</div>
      
      <div class="applicant-content base-scroller" ref="applicantContent">
        <template v-if="!layout.searchedCondition">
          <div
            class="applicant-group"
            :class="[`applicant-group-${letter}`]"
            v-for="letter in letterList"
            :key="letter"
          >
            <div class="group-title">{{ letter }}</div>
            <div class="group-content">
              <history-applicant-item
                v-for="item in applicantMap[letter]"
                :key="item.archives_id"
                :applicant-item="item"
              ></history-applicant-item>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="search-list">
            <history-applicant-item
              v-for="item in allApplicantList"
              :key="item.archives_id"
              :applicant-item="item"
            ></history-applicant-item>
          </div>
        </template>
        
        <div class="nodata" v-if="isNodata">
          <img
            class="nodata-img"
            src="https://o.666visa.cn/static/ssqpeer/product/history-applicant/nodata-img.png"
            alt=""
          />
          没有搜索到结果
        </div>
      </div>
      <div class="applicant-index-fixed" v-if="!layout.searchedCondition">
        <div
          @click="gotoIndexItem(letter)"
          class="index-item"
          :class="{ active: activeLetter === letter }"
          v-for="letter in letterList"
          :key="letter"
        >
          {{ letter }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 下单弹窗，还有个历史申请人，跟这个代码基本类似，所以修改请同步调整
import _ from 'lodash';
import Http from '../../../../libs/http';
import HistoryApplicantItem from './components/history-applicant-item.vue';

export default {
  components: {
    HistoryApplicantItem,
  },
  data() {
    return {
      applicantMap: {},
      condition: '',
      activeLetter: '',
      layout: {
        searchedCondition: '', // 获取数据后的参数
      },
    };
  },
  computed: {
    letterList() {
      if (!this.applicantMap) return [];
      return Object.keys(this.applicantMap).sort();
    },
    isNodata() {
      return Object.keys(this.applicantMap).length === 0;
    },
    allApplicantList() {
      return Object.keys(this.applicantMap).reduce((list, key) => list.concat(this.applicantMap[key]), []);
    },
  },
  created() {
    this.init();
  },
  mounted() {
    this.initScroll();
  },
  methods: {
    init() {
      this.applicantMap = {};
      this.activeLetter = '';
      const params = {
        condition: this.condition || undefined,
      };
      Http.post('/archives_brief_query', params)
        .then((data) => {
          delete data.result.unknown;
          this.applicantMap = data.result;
          this.layout.searchedCondition = params.condition;
          this.$nextTick(() => {
            this.computedActiveLetter();
          });
        })
        .catch((e) => {
          if (e) console.log(e);
        });
    },
    onChangeCondition: _.debounce(function () {
      this.init();
    }, 200),
    gotoIndexItem(letter) {
      if (!this.$refs.applicantContent) return;
      const el = this.$refs.applicantContent.querySelector(
        `.applicant-group-${letter}`,
      );
      if (!el) return;
      this.$refs.applicantContent.scrollTo({
        top: el.offsetTop,
        behavior: 'smooth',
      });
    },
    initScroll() {
      if (!this.$refs.applicantContent) return;
      this.$refs.applicantContent.addEventListener('scroll', () => {
        this.computedActiveLetter();
      });
    },
    computedActiveLetter() {
      if (!this.$refs.applicantContent) return;
      try {
        // 本质上就是从上往下找，然后找到最后一个锚点元素top小于0的，也就是当前激活的。
        let activeLetter = this.letterList[0];

        const scrollTop = this.$refs.applicantContent.scrollTop;
        for (let index = 0; index < this.letterList.length; index++) {
          const letter = this.letterList[index];
          const groupEl = this.$refs.applicantContent.querySelector(
            `.applicant-group-${letter}`,
          );
          if (groupEl && (groupEl.offsetTop - 5 < scrollTop)) {
            activeLetter = letter;
          } else {
            break;
          }
        }

        this.activeLetter = activeLetter;
      } catch (error) {
        //
        console.log(error);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.history-applicant {
  height: 600px;
  display: flex;
  flex-direction: column;
  .page-header {
    flex-shrink: 0;
    padding: 24px 24px 24px 24px;
    .search-input {
      width: 340px;
    }
  }
  .applicant-box {
    flex-grow: 1;
    overflow: hidden;
    position: relative;
    padding-bottom: 24px;
    .fixed-nav{
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      background: #fff;
      font-size: 16px;
      line-height: 22px;
      font-weight: 600;
      color: #2f333d;
      padding: 0 24px;
      height: 22px;
      display: flex;
      align-items: center;
      z-index: 1;
    }
    .applicant-content {
      max-height: 100%;
      overflow: auto;
      padding: 0 24px 24px 24px;
      
      .applicant-group {
        margin-bottom: 16px;
        &:last-child {
          margin-bottom: 0;
        }
        .group-title {
          font-size: 16px;
          line-height: 22px;
          font-weight: 600;
          color: #2f333d;
        }
        .group-content {
          margin-top: 16px;
          display: flex;
          flex-wrap: wrap;
          margin-bottom: -16px;
          
        }
      }
      
      .search-list{
        display: flex;
        flex-wrap: wrap;
        margin-bottom: -16px;
      }
      .nodata {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-top: 48px;
        color: #91999f;
        font-size: 16px;
        .nodata-img {
          width: 280px;
          height: 180px;
          margin-bottom: 10px;
        }
      }
    }
    .applicant-index-fixed {
      position: absolute;
      right: 24px;
      top: 50%;
      transform: translateY(-50%);
      display: flex;
      flex-direction: column;
      align-items: center;
      background: #f7f8fa;
      width: 16px;
      padding: 4px 0;
      border-radius: 1px;
      .index-item {
        font-size: 12px;
        line-height: 17px;
        color: #91999f;
        cursor: pointer;
        margin-bottom: 7px;
        &:last-child {
          margin-bottom: 0;
        }
        &:hover {
          color: #2f333d;
        }
        &.active {
          color: #2f333d;
          font-weight: 600;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/user-children/history-applicant/history-applicant.vue